import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompaniesComponent } from './companies/companies.component';
import { CreateOrEditCompanyComponent } from './companies/create-or-edit-company.component';
import { LocationsComponent } from './locations/locations.component';
import { CreateOrEditLocationComponent } from './locations/create-or-edit-location.component';
import { PaymentTermsComponent } from './paymentTerms/paymentTerms.component';
import { CreateOrEditPaymentTermDto } from '@shared/service-proxies/service-proxies';
import { CreateOrEditPaymentTermModalComponent } from './paymentTerms/create-or-edit-paymentTerm-modal.component';
import { CreateOrEditCurrencyModalComponent } from './currencies/create-or-edit-currency-modal.component';
import { CurrenciesComponent } from './currencies/currencies.component';
import { CreateOrEditPaymentTypeModalComponent } from './paymentTypes/create-or-edit-paymentType-modal.component';
import { PaymentTypesComponent } from './paymentTypes/paymentTypes.component';
import { TaxesComponent } from './taxes/taxes.component';
import { CreateOrEditTaxComponent } from './taxes/create-or-edit-tax.component';

const routes: Routes = [
  {
    path: 'companies',
    children: [
      {
        path: '',
        component: CompaniesComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditCompanyComponent,
      }
    ]
  },
  {
    path: 'locations',
    children: [
      {
        path: '',
        component: LocationsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditLocationComponent,
      }
    ]
  },
  {
    path: 'paymentTerms',
    children: [
      {
        path: '',
        component: PaymentTermsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditPaymentTermModalComponent,
      }
    ]
  },
    {
    path: 'paymentTypes',
    children: [
      {
        path: '',
        component: PaymentTypesComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditPaymentTypeModalComponent,
      }
    ]
  },
    {
    path: 'currencies',
    children: [
      {
        path: '',
        component: CurrenciesComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditCurrencyModalComponent,
      }
    ]
  },
    {
    path: 'taxes',
    children: [
      {
        path: '',
        component: TaxesComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditTaxComponent,
      }
    ]
  }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MasterRoutingModule {}
